import { createContext } from 'react';

// interface IAdminContext {
//     adminMode: boolean;
// }

export const AdminContext = createContext<boolean>(false);